import { useMutation, useQueryClient } from '@tanstack/react-query';
import sportsApi from '../../../utils/sportsApi';
import { CommonKey } from '../../../types/api';

const useArchiveCampaign = (clientId: number) => {
    const queryClient = useQueryClient();

    const archiveCampaign = async (campaignId: string) => {
        return sportsApi
            .url(`/clients/${clientId}/social-campaigns/${campaignId}`)
            .delete()
            .res();
    };

    const mutation = useMutation({
        mutationFn: archiveCampaign,
        onSuccess: (data, campaignId) => {
            queryClient.setQueryData(
                [CommonKey.Campaigns, clientId],
                (oldData: any) => {
                    // Ensure oldData is an array, default to empty array if not
                    const existingData = Array.isArray(oldData) ? oldData : [];
                    const campaigns = existingData.filter(
                        (campaign: any) => campaign.id !== campaignId,
                    );

                    return campaigns;
                },
            );
        },
    });

    return mutation;
};

export default useArchiveCampaign;
